import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class CountryService {
  private countries: any[] = []; // Array to hold country data
  private countriesSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(
    []
  ); // BehaviorSubject to hold current countries state

  constructor(private http: HttpClient) {
    // Inject HttpClient for API calls
    this.countriesSubject.next(this.countries); // Initialize the BehaviorSubject
  }

  // Method to set countries data
  setCountries(countries: any[]) {
    this.countries = countries;
    this.countriesSubject.next(this.countries); // Update BehaviorSubject with new data
  }

  // Method to get countries data as an Observable
  getCountries(): Observable<any[]> {
    return this.countriesSubject.asObservable(); // Return Observable of current countries
  }

  // Method to fetch countries from an API
  //   fetchCountries(): Observable<any[]> {
  //     return this.http.get<any[]>('api/countries') // Replace with your actual API endpoint
  //       .pipe(
  //         tap(countries => this.setCountries(countries)), // Update the local countries and BehaviorSubject
  //         catchError(this.handleError('fetchCountries', [])) // Handle errors
  //       );
  //   }

  // Error handling method
  // private handleError<T>(operation = 'operation', result?: T) {
  //   return (error: any): Observable<T> => {
  //     console.error(`${operation} failed: ${error.message}`); // Log error to console
  //     return of(result as T); // Return a safe result
  //   };
  // }
}
